import assetPath from '/app/packages/lebenslauf/articles/src/assets/der-perfekte-lebenslauf-welche-persoenlichen-daten-gehoeren-hinein.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')